import { PatientsAction, setIsSearching, setPatients } from './actions';
import { call, delay, put, select, takeLatest } from 'redux-saga/effects';

import { HealAPI } from '../../healApi';
import { RootState } from '../types';

function* handlePatientSearchChanged(): any {
  yield delay(300);
  const state: RootState = yield select((s) => s);
  if (state.patients.searchText && state.patients.searchText.length > 2) {
    yield put(setIsSearching(true));
    const result = yield call(HealAPI.searchPatient, state.patients.searchText);
    if (result.data) {
      yield put(setPatients(result.data));
    }
    yield put(setIsSearching(false));
  }
}

export function* patientsSearchFlow() {
  yield takeLatest(PatientsAction.PATIENT_SEARCH_CHANGED, handlePatientSearchChanged);
}
